import { MutableRefObject, useEffect } from 'react';
import { BehaviorSubject, from } from 'rxjs';
import { CategoriesApi } from 'api/timesheets/categories';
import { logger } from 'services';
import { Categories, empty } from './core';
import { loaded, loading } from './loading';

const NO_OP = () => {};

export const useInitialize = (
  categories$: MutableRefObject<BehaviorSubject<Categories>>,
  initialized: boolean,
  setInitialized: (next: boolean) => void,
) =>
  useEffect(() => {
    if (initialized) {
      return NO_OP;
    }

    categories$.current.next(loading(categories$.current.value));
    const subscription = from(CategoriesApi.get()).subscribe(
      (categories) =>
        categories$.current.next(loaded(categories)(categories$.current.value)),
      (error: Error) => {
        logger.error('failed to fetch time entry categories', { error });
        categories$.current.next(empty());
      },
      () => setInitialized(true),
    );

    return () => subscription.unsubscribe();
  }, [initialized, categories$, setInitialized]);
